
export enum EuEuUserAddedInsuranceStatusInternal{

  pending,
  in_processing,
  processed,
  not_relevant

}
